export const authFetch = async (url, options = {}, navigate) => {
  const token = localStorage.getItem("token");
  const headers = {
    ...(options.headers || {}),
    Authorization: token ? `Bearer ${token}` : "",
  };

  const res = await fetch(url, { ...options, headers });

  if (res.status === 401) {
    // expired or invalid token
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("userEmail");
    navigate("/login");
    throw new Error("Unauthorized – redirected to login");
  }

  return res;
};
